module.exports = __webpack_public_path__ + "static/media/biteship-dashboard-api.9e57e790.png";